import { useState } from 'react';
import { Box, Modal } from '@mui/material';

import { ATSPrincipalAppCandidateModalTestIds } from 'data-testids/ATS';
import { CandidateModalContainer } from '../styles';
import { CandidateModalProps } from 'features/Principal/types/modalTypes';
import { CandidateModalHeader } from './tabs/CandidateModalHeader';
import { CandidateModalTabs } from './tabs/CandidateModalTabs';
import { CandidateActionButtonsContainer } from '../components/CandidateActionButtonsContainer';
import EmailModal from 'components/EmailModal';
import {
  trackPrincipalCandidateContactClicked,
  trackPrincipalCandidateEmailSent,
} from 'utils/pendoTracking';

export const CandidateModal: React.FC<CandidateModalProps> = ({ open, onClose, currentRow }) => {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  const trackingPayload = {
    application_id: currentRow.application?.id,
    candidate_id: currentRow.candidate.id,
    candidate_email: currentRow.candidate.email,
    job_id: currentRow.role?.id,
  };

  const handleEmailClick = () => {
    trackPrincipalCandidateContactClicked(trackingPayload);
    setIsEmailModalOpen(true);
  };

  const handleSendEmail = () => {
    trackPrincipalCandidateEmailSent({ ...trackingPayload, feature: 'candidate_messaging' });
    setIsEmailModalOpen(false);
  };

  return (
    <>
      <Modal
        sx={{ '.MuiBox-root': { maxHeight: '80%', overflow: 'auto' } }}
        style={isEmailModalOpen ? { pointerEvents: 'none' } : undefined}
        open={open}
        onClose={onClose}
        hideBackdrop={isEmailModalOpen}
        disableEnforceFocus={isEmailModalOpen}
        disableAutoFocus={isEmailModalOpen}
        data-testid={ATSPrincipalAppCandidateModalTestIds.MODAL}
      >
        <CandidateModalContainer
          sx={{
            maxWidth: '900px',
            borderRadius: 2,
            visibility: isEmailModalOpen ? 'hidden' : 'visible',
          }}
          data-testid={ATSPrincipalAppCandidateModalTestIds.MODAL_CONTAINER}
        >
          <CandidateModalHeader row={currentRow} />
          <Box sx={{ mt: '8px' }}>
            <CandidateModalTabs row={currentRow} onEmailClick={handleEmailClick} />
          </Box>
          {currentRow?.application && (
            <CandidateActionButtonsContainer
              applicationId={currentRow.application.id}
              initialStatus={currentRow.candidate_stage}
              variant="modal"
              onSuccess={onClose}
            />
          )}
        </CandidateModalContainer>
      </Modal>
      {isEmailModalOpen && (
        <EmailModal
          show={isEmailModalOpen}
          recipientList={[
            {
              name: `${currentRow.candidate.first_name} ${currentRow.candidate.last_name}`,
              email: currentRow.candidate.email,
            },
          ]}
          onHide={() => setIsEmailModalOpen(false)}
          onSend={handleSendEmail}
          subject=""
          message=""
          showTemplates={false}
        />
      )}
    </>
  );
};
